import { skipToken } from '@tanstack/react-query';
import { useMemo } from 'react';
import { RecordDraft } from '../../types/sharedTypeImpl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';


export function useLoadProtocol(
    record: RecordDraft | null,
) {

    const protocolFetch = trpc.protocols.getById.useQuery(
        record?.protocolId ?? skipToken,
        { staleTime: Infinity },
    );

    const pdfFetch = trpc.protocolFiles.getPdf.useQuery(
        record ? { protocolId: record.protocolId } : skipToken,
        { staleTime: Infinity },
    );


    const visualPositions = useMemo(() => {
        if (!protocolFetch.data) return [];
        return protocolFetch.data.positions.filter(
            it => it.type === 'visualInspection' &&
                it.imageFileName !== undefined
        );
    }, [protocolFetch.data]);

    const inspectionQueries = trpc.useQueries((t) =>
        visualPositions.map((it, index) =>
            t.protocolFiles.getVisualInspectionImage(
                {
                    imageFileName: it.imageFileName ?? '',
                    index
                },
                {
                    enabled: it.imageFileName !== undefined,
                    refetchOnWindowFocus: false,
                }
            )
        ) ?? []
    );

    const positionImages = useMemo(() => {
        const images = new Map<string, Uint8Array>();
        visualPositions?.forEach((it, index) => {
            if (inspectionQueries[index].data) {
                images.set(it.positionNumber, inspectionQueries[index].data);
            }
        });
        return images;
    }, [visualPositions, inspectionQueries]);


    return {
        protocol: protocolFetch.data,
        protocolFetch,
        pdfFetch,
        positionImages,
    }
}
